export const DEFAULT_ERROR_MESSAGE =
  '오류가 발생했습니다 개발자에게 문의해주세요';
